import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=3c361cb8&scoped=true&"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=3c361cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c361cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c361cb8')) {
      api.createRecord('3c361cb8', component.options)
    } else {
      api.reload('3c361cb8', component.options)
    }
    module.hot.accept("./SkeletonLoader.vue?vue&type=template&id=3c361cb8&scoped=true&", function () {
      api.rerender('3c361cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SkeletonLoader.vue"
export default component.exports